function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.509 0C12.729 0 5.366 4.786 0 4.786V43.483C5.366 43.483 12.729 38.697 20.509 38.697C25.093 38.697 27.966 40.587 29.692 42.479H34.309C36.036 40.589 38.908 38.697 43.492 38.697C51.272 38.697 58.635 43.483 64.001 43.483V4.786C58.635 4.786 51.272 0 43.492 0C34.324 0 32.001 7.565 32.001 7.565C32.001 7.565 29.677 0 20.51 0H20.509ZM20.509 42.964C12.73 42.964 5.367 47.75 0 47.75V52.017C5.366 52.017 12.729 47.231 20.509 47.231C25.093 47.231 27.966 49.123 29.692 51.013H34.309C36.036 49.123 38.908 47.231 43.492 47.231C51.272 47.231 58.635 52.017 64.001 52.017V47.75C58.635 47.75 51.272 42.964 43.492 42.964C38.908 42.964 36.035 44.856 34.309 46.746H29.692C27.965 44.854 25.093 42.964 20.509 42.964V42.964Z",
  fill: "white"
});

function SvgWelcomeBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBook);
export default __webpack_public_path__ + "static/media/welcomeBook.db2241f9.svg";
export { ForwardRef as ReactComponent };